import React from "react";
import { View, Text, Pressable, ScrollView, StyleSheet, Dimensions } from "react-native";
import { Ionicons } from "@expo/vector-icons";
import { spotlightTargetWhen } from "../../../Widgets/SpotlightTutorial/spotlightTargets";

const isMobile = Dimensions.get("window").width < 768;

export const REGISTRY_SETUP_COLORS = {
	cream: "#fefde2",
	green: "#4c956c",
	darkGreen: "#2c6e49",
	border: "#e2e8f0",
	text: "#1e293b",
	mutedText: "#64748b",
};

/** The cream card shared by every step of the Create Your Registry flow. */
const RegistrySetupModal = ({ title, subtitle, icon, onClose, footer, targetId, children }) => (
	<View style={styles.card} {...spotlightTargetWhen(Boolean(targetId), targetId)}>
		{onClose && (
			<Pressable style={styles.closeButton} onPress={onClose} accessibilityRole="button" accessibilityLabel="Close">
				<Ionicons name="close" size={20} color={REGISTRY_SETUP_COLORS.mutedText} />
			</Pressable>
		)}
		<View style={styles.header}>
			{icon && <Ionicons name={icon} size={56} color={REGISTRY_SETUP_COLORS.green} style={styles.headerIcon} />}
			<Text style={styles.title}>{title}</Text>
			{subtitle && <Text style={styles.subtitle}>{subtitle}</Text>}
		</View>
		<ScrollView style={styles.body} contentContainerStyle={styles.bodyContent}>
			{children}
		</ScrollView>
		{footer && <View style={styles.footer}>{footer}</View>}
	</View>
);

const styles = StyleSheet.create({
	card: {
		width: isMobile ? "92%" : "90%",
		maxWidth: 760,
		maxHeight: "90vh",
		backgroundColor: REGISTRY_SETUP_COLORS.cream,
		borderRadius: 20,
		borderWidth: 1,
		borderColor: REGISTRY_SETUP_COLORS.border,
		shadowColor: "#000",
		shadowOffset: { width: 0, height: 8 },
		shadowOpacity: 0.15,
		shadowRadius: 24,
		elevation: 8,
		overflow: "hidden",
	},
	closeButton: {
		position: "absolute",
		top: 12,
		right: 12,
		zIndex: 2,
		width: 36,
		height: 36,
		borderRadius: 18,
		alignItems: "center",
		justifyContent: "center",
		backgroundColor: "rgba(255, 255, 255, 0.8)",
	},
	header: {
		alignItems: "center",
		paddingTop: isMobile ? 24 : 32,
		paddingHorizontal: isMobile ? 48 : 64,
		paddingBottom: 12,
	},
	headerIcon: {
		marginBottom: 8,
	},
	title: {
		fontFamily: "Orpheus Pro",
		fontSize: isMobile ? 22 : 28,
		fontWeight: "600",
		color: REGISTRY_SETUP_COLORS.darkGreen,
		textAlign: "center",
	},
	subtitle: {
		marginTop: 8,
		fontSize: isMobile ? 14 : 16,
		lineHeight: 22,
		color: REGISTRY_SETUP_COLORS.mutedText,
		textAlign: "center",
	},
	body: {
		flexShrink: 1,
	},
	bodyContent: {
		paddingHorizontal: isMobile ? 16 : 28,
		paddingVertical: 12,
	},
	footer: {
		paddingHorizontal: isMobile ? 16 : 28,
		paddingVertical: 16,
		borderTopWidth: 1,
		borderTopColor: REGISTRY_SETUP_COLORS.border,
		backgroundColor: REGISTRY_SETUP_COLORS.cream,
	},
});

export default RegistrySetupModal;
